import ReferenceAppDownload from "../component/ReferenceAppDownload";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { isEmpty } from "lodash";
import { FaBookOpen, FaCoins, FaMoneyBillWave, FaPiggyBank } from "react-icons/fa";
import { useContextSelector } from "use-context-selector";
import ThemeContext from "../context/ThemeContext";
import AuthContext from "../context/AuthContext";
import { Fishing, HomeCasino, LiveCasino, Slots } from "./casino/CasinoList";
import referenceBanners from "./referenceBanners.json";
import referencePromotions from "./referencePromotions.json";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import referenceArtwork from "./referenceArtwork.json";
import GameSwiper from "./casino/GameSwiper";
import ReferenceJackpot from "../component/ReferenceJackpot";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "./ReferenceHome.css";

const homeGames = referenceArtwork.map(art => ({ ...HomeCasino.HotGame.find(game => game.name === art.name), ...art }));
const categories = [
  { key: "hot", label: "Hot", labelBn: "হট", icon: "hot-flame.png", games: homeGames },
  { key: "slot", label: "Slot", labelBn: "স্লট", icon: "nav-rng.png", games: Slots.slice(0, 15) },
  { key: "live", label: "Live", labelBn: "লাইভ", icon: "nav-live.png", games: LiveCasino.slice(0, 15) },
  { key: "fishing", label: "Fishing", labelBn: "ফিশিং", icon: "nav-fish.png", games: Fishing.slice(0, 15) },
  { key: "poker", label: "Poker", labelBn: "পোকার", icon: "nav-pvp.png", games: HomeCasino.Poker.slice(0, 15) },
];
const quickActions = [
  { key: "deposit", label: "Deposit", labelBn: "জমা", Icon: FaPiggyBank },
  { key: "withdraw", label: "Withdraw", labelBn: "উত্তোলন", Icon: FaMoneyBillWave },
  { key: "rebate", label: "Cashback", labelBn: "ক্যাশব্যাক", Icon: FaCoins },
  { key: "mission", label: "Mission", labelBn: "মিশন", Icon: FaBookOpen },
];

export default function ReferenceHome() {
  const messages = useContextSelector(ThemeContext, ctx => ctx.message);
  const announcementMessages = messages?.filter(item => item.message?.trim() && !/^welcome to/i.test(item.message.trim())).map(item => item.message) || [];
  const noticeItems = announcementMessages.length ? announcementMessages : ["দৈনিক প্রথম জমাতে ২০% বোনাস", "👑 প্রথম জমা বোনাস সর্বোচ্চ ৮৮,৮৮৮", "🎉 প্রতি শনিবার সুপার বোনাস দিবস!", "chorki অ্যাপ ডাউনলোড করুন", "Welcome to chorki!"];
  const lang = useContextSelector(AuthContext, ctx => ctx.lang);
  const user = useContextSelector(AuthContext, ctx => ctx.user);
  const setLoginModal = useContextSelector(AuthContext, ctx => ctx.setLoginModal);
  const [activeCategory, setActiveCategory] = useState("hot");
  const categoryTabs = useRef(null);
  const heroBanners = referenceBanners;
  const promoCards = referencePromotions.slice(0, 6);
  const selectedCategory = categories.find(category => category.key === activeCategory);
  const memberPath = key => isMobile && ["deposit", "withdraw"].includes(key) ? `/member/${key}` : `/member?tab=${key}`;
  const requireLogin = event => {
    if (isEmpty(user)) {
      event.preventDefault();
      setLoginModal(true);
    }
  };
  const handleCategoryKeyDown = (event, index) => {
    const nextIndex = { ArrowRight: (index + 1) % categories.length, ArrowLeft: (index + categories.length - 1) % categories.length, Home: 0, End: categories.length - 1 }[event.key];
    if (nextIndex === undefined) return;
    event.preventDefault();
    const tab = categoryTabs.current.querySelectorAll('[role="tab"]')[nextIndex];
    tab.focus();
    tab.click();
  };
  return (
    <main className="ref-home br_main">
      <div className="ref-banners"><Swiper modules={[A11y, Autoplay, Pagination]} slidesPerView={1} loop pagination={{ clickable: true }} autoplay={{delay:5000,disableOnInteraction:false,pauseOnMouseEnter:true}}>{heroBanners.map(banner => <SwiperSlide key={banner.id}><div className="ref-banner-art"><img src={banner.src} alt="Chorki promotion" /></div></SwiperSlide>)}</Swiper></div>
      <nav className="ref-home-actions" aria-label="Wallet and rewards">
        {quickActions.map(({ key, label, labelBn, Icon }) => (
          <Link key={key} to={memberPath(key)} onClick={requireLogin}>
            <Icon aria-hidden="true" />
            <span>{lang === "en" ? label : labelBn}</span>
          </Link>
        ))}
      </nav>
      <button type="button" className="ref-announcement" aria-label={lang === "en" ? "Announcements" : "ঘোষণা"} onClick={() => window.dispatchEvent(new CustomEvent("chorki-open-announce"))}>
        <img src="/assets/bdtwin/notice-bell.png" alt="" />
        <div className="ref-announcement-window"><div className="ref-announcement-text">{[0, 1].map(copy => <div className="ref-announcement-set" key={copy} aria-hidden={copy === 1 || undefined}>{noticeItems.map((message, index) => <span key={index}>{message}</span>)}</div>)}</div></div>
      </button>
      <ReferenceJackpot lang={lang} />
      <section className="ref-home-games" aria-label={lang === "en" ? "Games" : "গেমস"}>
        <div className="ref-home-categories" role="tablist" aria-label="Game categories" ref={categoryTabs}>
          {categories.map(({ key, label, labelBn, icon }, index) => (
            <button key={key} id={`home-tab-${key}`} type="button" role="tab" aria-selected={activeCategory === key} aria-controls="home-game-panel" tabIndex={activeCategory === key ? 0 : -1} className={activeCategory === key ? "active" : ""} onKeyDown={event => handleCategoryKeyDown(event, index)} onClick={event => {
              setActiveCategory(key);
              event.currentTarget.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
            }}>
              <img src={`/assets/bdtwin/${icon}`} alt="" />
              <span>{lang === "en" ? label : labelBn}</span>
            </button>
          ))}
        </div>
        <div id="home-game-panel" role="tabpanel" aria-labelledby={`home-tab-${activeCategory}`} tabIndex={0}>
          <GameSwiper key={activeCategory} list={selectedCategory.games} presentation="home-grid" />
        </div>
      </section>
      <section className="ref-promotions" aria-label="Promotion"><div className="ref-section-heading"><img src="/assets/bdtwin/home-promotion-gift.png" alt="" /><h2>{lang === "en" ? "Promotion" : "প্রমোশন"}</h2><Link className="ref-more" to="/promotions">{lang === "en" ? "More" : "আরও"} <span aria-hidden="true">›</span></Link></div><div className="ref-offer-grid">{promoCards.map((offer) => <Link key={offer.id} to="/promotions"><img src={offer.src} alt={offer.title || "Promotion"} /><span>{lang === "en" ? "See more" : "আরও দেখুন"}</span></Link>)}</div></section>
      <ReferenceAppDownload />

    </main>
  );
}
